// import ModalForm from "./Form";
import ParentListForm from "./ParentListForm";
import { PARENT, DATATABLE_EXPORT } from "../../../../../Config/ApiUrl";
import * as actions from "../../../../../Config/ApiUrl";

export const Schema = {
	components: { ParentListForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			Endpoint: PARENT,
			tableId: "parent-list-table",
			formId: "parent-list-form",
			rowData: {},
			tableColumns: [
				{
					title: "Name",
					type: "text",
					key: "name",
				},
				{
					title: "Is Mother",
					type: "custom-html",
					key: "is_mother",
					isVisible: true,
					modifier: (value) => {
						return value == 1 ? 'Yes' : 'No';
					}
				},
				{
					title: "Contact",
					type: "text",
					key: "contact",
				},
				{
					title: "WhatsApp",
					type: "text",
					key: "whatsapp",
				},
			],
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "ParentListTable",
				url: PARENT,
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				actions: [
					{
						title: this.$t("edit"),
						icon: "edit",
						type: "none",
						component: "app-add-modal",
						// component: "parent-list-form",
						modalId: "parent-list-form",
						modifier: () => this.$can('view_list_parent_button_modalupdateinfo')
					},
					{
						title: "Parent Profile",
						icon: "user", // You can use an appropriate icon here
						type: "page", // or "page" if you want to navigate to a new page
						url: "/transaction/profile-parent", // Specify the URL you want to navigate to
						target: "", // "_blank" if you want to open the URL in a new tab
						uniqueKey: (rowData) => rowData.id,
						modifier: () => this.$can('view_list_parent_button_parentprofile')
					},
					// {
					// 	title: this.$t("delete"),
					// 	icon: "trash",
					// 	type: "none",
					// 	component: "app-confirmation-modal",
					// 	modalId: "demo-delete",
					// },
				],
				filters: [
				],
				showFilter: true,
				showSearch: true,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 10,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {
		isPifDisabled(rowData) {
			if (rowData.status === "inactive") return true;
			else if (rowData.status === "not_interested") return true;
			else if (rowData.status === "invalid") return true;
			else return false;
		},
	},
};
